<template>
    <tabs-section
        class="c-field_tags"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"
        :title="title"
        :empty="value && value.length === 0"
        :saved="value !== null"
        @history="openHistory"
        @next="save">

        <visit-history-previous
            v-if="lastVisit !== null && lastValueExist"
            @copy="copyValue">
            {{ lastValue }}
        </visit-history-previous>

        <form-tag-select-input
            :label="label"
            :name="name"
            v-model="newValue"
            :ajax-url="ajaxUrl"
            :format-item="formatItem"
            speech-to-text>
        </form-tag-select-input>

        <visit-history-modal ref="tagsHistoryModal" :title="title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_tags__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                <ul v-if="item.value.length" class="c-field_tags__history-tags">
                    <form-tag
                        v-for="(tag, index) in item.value"
                        :key="index"
                        :title="tag">
                    </form-tag>
                </ul>
                <p v-else>Brak elementów</p>
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>
</template>


<script>

import {mapGetters} from 'vuex'
import {FormTagSelectInput, FormTag} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'

import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'
import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'

import noReact from 'Utils/NoReact'


export default {

    name: 'VisitFieldTagsSelect',

    props: {
        value: Array,
        name: String,
        label: String,
        title: String,
        ajaxUrl: String,
        formatItem: Function,
    },

    data() {
        return {
            fieldHistory: [],
            newValue: noReact(this.value) || []
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit']),
        lastValueExist() {
            return typeof this.lastVisit[this.name] !== 'undefined'
                && this.lastVisit[this.name] !== null
                && this.lastVisit[this.name].length > 0
        },
        lastValue() {
            return this.lastValueExist ? this.lastVisit[this.name].join(', ') : ''
        },
        nextLabel() {
            if (!this.isEdited || (this.value === null && this.newValue.length === 0))
                return 'Dalej'
            return 'Zapisz'
        },
        isEdited() {
            return !this.newValue.compare(this.value)
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: this.newValue,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 2000)
                nextSection()
            }).catch((error) => {
                this.$alert.error('Przebieg wizyty', error.response.data.message)
                nextSection(false)
            })
        },
        openHistory() {
            this.$refs.tagsHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = history
        },
        copyValue() {
            this.newValue = Array.from(new Set(this.newValue.concat(this.lastVisit[this.name])))
        }
    },

    components: {
        VisitHistoryPrevious,
        VisitHistoryItem,
        VisitHistoryModal,
        FormTagSelectInput,
        FormTag,
        TabsSection
    }
}


</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-field_tags {
    &__history {
        &-tags {
            margin: 1rem -0.3rem;
            width: 100%;
            min-height: 3rem;
        }
    }
}

</style>

